import React, { FC } from 'react';

export interface SearchTabsProps {
  activeTab: 'keyword' | 'map';
  onTabChange: (tab: 'keyword' | 'map') => void;
}

const SearchTabs: FC<SearchTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="p-tabs">
      <button
        type="button"
        className={`c-button c-button--search-left p-tabs__item ${
          activeTab === 'keyword' ? 'p-tabs__item--active' : ''
        }`}
        onClick={() => onTabChange('keyword')}
      >
        キーワード検索
      </button>
      <button
        type="button"
        className={`c-button c-button--map p-tabs__item ${activeTab === 'map' ? 'p-tabs__item--active' : ''}`}
        onClick={() => onTabChange('map')}
      >
        現在地から検索
      </button>
    </div>
  );
};

export default SearchTabs;
